import {
  DrawerHeader,
  Step,
  Stepper,
  useSwipeableViews,
} from '@cast/design-system';

type EdgeLocationDrawerHeaderProps = {
  isReviewingScript: boolean;
};

export const EdgeLocationDrawerHeader = ({
  isReviewingScript,
}: EdgeLocationDrawerHeaderProps) => {
  const ctx = useSwipeableViews();

  return (
    <DrawerHeader>
      {!isReviewingScript && (
        <Stepper
          testId="edge-location-creation-stepper"
          sx={{
            width: 320,
            position: 'absolute',
            top: 20,
            right: 85,
          }}
          activeStep={ctx?.currentSlideIndex}
          size="small"
        >
          <Step label="Configure location" />
          <Step label="Select add-ons" />
          <Step label="Establish connection" />
        </Stepper>
      )}
    </DrawerHeader>
  );
};
